// extracted by mini-css-extract-plugin
export default {"title":"GuardiansAndPatientsPanel_title__jydrJ"};